document.addEventListener( 'DOMContentLoaded', function() {
	const sliderContainers = document.querySelectorAll(".wp-block-moods-blocks-slider-3");

	sliderContainers.forEach((container) => {

		const mainSwiperContainerEl = container.querySelector('.main-swiper-container');
		const mainSwiperEl = mainSwiperContainerEl.querySelector('.swiper');
		const mainSwiperPaginationEl = mainSwiperContainerEl.querySelector('.swiper-pagination');
		const mainSwiperNextButtonEl = mainSwiperContainerEl.querySelector('.swiper-button-next');
		const mainSwiperPrevButtonEl = mainSwiperContainerEl.querySelector('.swiper-button-prev');

		new Swiper(mainSwiperEl, {
			pagination: {
				el: mainSwiperPaginationEl,
				clickable: true,
			},
			loop: true,
			slidesPerView: 'auto',
			centeredSlides: true,
			spaceBetween: 30,
			navigation: {
				nextEl: mainSwiperNextButtonEl,
				prevEl: mainSwiperPrevButtonEl,
			},
		});
	})
});
